import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=1aa2ddd5&scoped=true&"
import script from "./InventoryView.vue?vue&type=script&lang=ts&"
export * from "./InventoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2ddd5",
  null
  
)

export default component.exports